import { render, staticRenderFns } from "./warn.vue?vue&type=template&id=4bb1fc18&scoped=true"
import script from "./warn.vue?vue&type=script&lang=js"
export * from "./warn.vue?vue&type=script&lang=js"
import style0 from "./warn.vue?vue&type=style&index=0&id=4bb1fc18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb1fc18",
  null
  
)

export default component.exports